/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  UserModerationsModeratorControllerPatchMutationRequest,
  UserModerationsModeratorControllerPatchMutationResponse,
  UserModerationsModeratorControllerPatchPathParams,
  UserModerationsModeratorControllerPatch401,
  UserModerationsModeratorControllerPatch404,
} from '../../types/UserModerationsModeratorControllerPatch.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { userModerationsModeratorPatch } from '../../methods/userModerationsModeratorPatch.ts';
import { useMutation } from '@tanstack/react-query';

export const userModerationsModeratorPatchMutationKey = () => [{ url: '/api/moderator/user-moderations/:id' }] as const;

export type UserModerationsModeratorPatchMutationKey = ReturnType<typeof userModerationsModeratorPatchMutationKey>;

/**
 * {@link /api/moderator/user-moderations/:id}
 */
export function useUserModerationsModeratorPatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UserModerationsModeratorControllerPatchMutationResponse,
      ResponseErrorConfig<UserModerationsModeratorControllerPatch401 | UserModerationsModeratorControllerPatch404>,
      {
        id: UserModerationsModeratorControllerPatchPathParams['id'];
        data?: UserModerationsModeratorControllerPatchMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<UserModerationsModeratorControllerPatchMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? userModerationsModeratorPatchMutationKey();

  return useMutation<
    UserModerationsModeratorControllerPatchMutationResponse,
    ResponseErrorConfig<UserModerationsModeratorControllerPatch401 | UserModerationsModeratorControllerPatch404>,
    {
      id: UserModerationsModeratorControllerPatchPathParams['id'];
      data?: UserModerationsModeratorControllerPatchMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return userModerationsModeratorPatch(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
